import React from "react";

import { currentEnvironmentFromLocation } from "../utils/environmentDomain";

export default function EnvironmentPill({
  className = "",
  hideInProduction = true,
  dataTestId = "environment-pill",
  environmentOverride = null,
}) {
  const environment = environmentOverride || currentEnvironmentFromLocation();

  if (!environment) return null;
  if (hideInProduction && environment.isProduction) return null;

  const classes = [
    "inline-flex items-center rounded-full border border-amber-300 bg-amber-100 px-3 py-1 text-xs font-semibold tracking-wide text-amber-900",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} data-testid={dataTestId}>
      Environment: {environment.environmentLabel}
    </span>
  );
}
